import { IDynamicComponentManifest, IEditorManifest } from '@adaptiva/core/loaders';

const DYNAMIC_COMPONENTS: IDynamicComponentManifest[] = [
	{
		componentId: 'CloudRelayDiscoveryModeActionOverlayComponent',
		path: 'cloud-relay-discovery-mode',
		loadChildren: () => import('./builds/hosting/components/actions').then(m => m.CloudRelayDiscoveryModeActionOverlayComponentModule)
	},
	{
		componentId: 'CloudRelayServerActionOverlayComponent',
		path: 'cloud-relay-server',
		loadChildren: () => import('./builds/hosting/components/actions/cloud-relay-server-action-overlay/cloud-relay-server-action-overlay.component.module').then(
			m => m.CloudRelayServerActionOverlayComponentModule
		)
	},
	{
		componentId: 'EndOfLifeProductEditorActionOverlayComponent',
		path: 'end-of-life-product-editor',
		loadChildren: () => import('./builds/hosting/components/actions').then(
			m => m.EndOfLifeProductEditorActionOverlayComponentModule
		)
	},
	{
		componentId: 'ViewCveInfoActionOverlayComponent',
		path: 'view-cve-info',
		loadChildren: () => import('./builds/hosting/components/actions').then(
			m => m.ViewCveInfoActionOverlayComponentModule
		)
	},
	{
		componentId: 'CloudSignupOverlayComponent',
		path: 'cloud-signup',
		loadChildren: () => import('./components/actions/cloud-signup').then(m => m.CloudSignupOverlayModule)
	},
];

export const DYNAMIC_HOSTING_COMPONENT_MANIFESTS: (IDynamicComponentManifest | IEditorManifest)[] = [
	...DYNAMIC_COMPONENTS,
];
